module.exports = __webpack_public_path__ + "static/img/COLLINGWOOD.d8b821a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COLLINGWOOD.svg
// module id = ntsG
// module chunks = 0